export default __webpack_public_path__ + "static/media/close-circle.33174286.svg";